"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormComponent = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(FormComponent, _PureComponent);

  var _super = _createSuper(FormComponent);

  function FormComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, FormComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      values: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (field, value) {
      _this.setState(function (prev) {
        return {
          values: _objectSpread(_objectSpread({}, prev.values), {}, (0, _defineProperty2.default)({}, field.output_variable, value))
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", function (e) {
      e.preventDefault();
      var labels = {};

      var _iterator = _createForOfIteratorHelper(_this.props.component.form_fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          labels[field.output_variable] = field.placeholder;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this.props.onSubmit(_this.state.values, labels);
    });
    return _this;
  }

  (0, _createClass2.default)(FormComponent, [{
    key: "renderField",
    value: function renderField(field) {
      var _this$state$values$fi,
          _this2 = this;

      var value = (_this$state$values$fi = this.state.values[field.output_variable]) !== null && _this$state$values$fi !== void 0 ? _this$state$values$fi : '';

      if (field.input_type === 'LONG_TEXT') {
        return (0, _preact.h)("textarea", {
          className: "forethought-agent__form-input",
          placeholder: field.placeholder,
          value: value,
          disabled: this.props.disabled,
          onInput: function onInput(e) {
            return _this2.handleChange(field, e.target.value);
          }
        });
      }

      if (field.input_type === 'MULTI_SELECT_LIST') {
        return (0, _preact.h)("select", {
          className: "forethought-agent__form-input",
          value: value,
          disabled: this.props.disabled,
          onChange: function onChange(e) {
            return _this2.handleChange(field, e.target.value);
          }
        }, (0, _preact.h)("option", {
          value: ""
        }, field.placeholder), field.list_options.map(function (opt) {
          return (0, _preact.h)("option", {
            key: opt,
            value: opt
          }, opt);
        }));
      }

      return (0, _preact.h)("input", {
        className: "forethought-agent__form-input",
        type: FormComponent.inputTypeAttr(field.input_type),
        placeholder: field.placeholder,
        value: value,
        disabled: this.props.disabled,
        onInput: function onInput(e) {
          return _this2.handleChange(field, e.target.value);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          component = _this$props.component,
          disabled = _this$props.disabled;
      return (0, _preact.h)("form", {
        className: "forethought-agent__form",
        onSubmit: this.handleSubmit
      }, (0, _preact.h)("div", {
        className: "forethought-agent__form-message",
        dangerouslySetInnerHTML: {
          __html: component.message
        }
      }), component.form_fields.map(function (field) {
        return (0, _preact.h)("label", {
          key: field.output_variable,
          className: "forethought-agent__form-field"
        }, _this3.renderField(field));
      }), (0, _preact.h)("button", {
        type: "submit",
        className: "forethought-agent__form-submit",
        disabled: disabled
      }, "Submit"));
    }
  }], [{
    key: "inputTypeAttr",
    value: function inputTypeAttr(input) {
      switch (input) {
        case 'EMAIL':
          return 'email';

        case 'PHONE_NUMBER':
          return 'tel';

        case 'NUMBER':
          return 'number';

        default:
          return 'text';
      }
    }
  }]);
  return FormComponent;
}(_preactCompat.PureComponent);

var _default = FormComponent;
exports.default = _default;